import { AxiosRequestConfig, AxiosResponse } from "axios";
import { ErrorTransform } from "../utils/serviceHelper";
import { NotMigrated } from "./NotMigrated";

/**
 * WSService used to wrap our axios instances for the legacy v1/v2 API.
 *
 * The v1/v2 API is deprecated: instead of making a network request, every
 * method now throws `NotMigrated`. The class, its constructor and its method
 * signatures are kept intact so that all existing services, queries and
 * mutations continue to type-check — they simply throw when invoked.
 */

export class WSService {
  serviceRoot = "";
  errorTransforms: ErrorTransform[] = [];

  constructor(serviceRoot: string, errorTransforms?: ErrorTransform[]) {
    this.serviceRoot = serviceRoot;
    if (errorTransforms && errorTransforms.length > 0) {
      this.errorTransforms.push(...errorTransforms);
    }
  }

  async get<T = any>(
    url: string,
    _config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    throw new NotMigrated("GET", this.serviceRoot, url);
  }

  async post<T = any>(
    url: string,
    _data?: any,
    _config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    throw new NotMigrated("POST", this.serviceRoot, url);
  }

  async patch<T = any>(
    url: string,
    _data?: any,
    _config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    throw new NotMigrated("PATCH", this.serviceRoot, url);
  }

  async delete<T = any>(
    url: string,
    _config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    throw new NotMigrated("DELETE", this.serviceRoot, url);
  }
}
